<script setup lang="ts">
import { onMounted, onUnmounted } from 'vue'
import { Trash2, X } from 'lucide-vue-next'

const props = defineProps<{ src: string; alt?: string; removable?: boolean; removing?: boolean }>()
const emit = defineEmits<{ close: []; remove: [] }>()

function onKeydown(event: KeyboardEvent) {
  if (event.key === 'Escape') emit('close')
}
onMounted(() => window.addEventListener('keydown', onKeydown))
onUnmounted(() => window.removeEventListener('keydown', onKeydown))
</script>

<template>
  <Teleport to="body">
    <div class="lightbox" role="dialog" aria-modal="true" :aria-label="props.alt || 'Foto em tamanho real'" @click.self="emit('close')">
      <button type="button" class="close" aria-label="Fechar" @click="emit('close')"><X :size="22"/></button>
      <img :src="props.src" :alt="props.alt || 'Foto'">
      <button v-if="props.removable" type="button" class="remove" :disabled="props.removing" @click="emit('remove')">
        <Trash2 :size="18"/>{{ props.removing ? 'Removendo…' : 'Remover foto' }}
      </button>
    </div>
  </Teleport>
</template>

<style scoped>
.lightbox{position:fixed;inset:0;z-index:100;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:16px;padding:24px;background:rgba(22,19,15,.92)}
.lightbox img{max-width:100%;max-height:75vh;object-fit:contain;border-radius:var(--radius-md);box-shadow:var(--shadow-xl)}
.close{position:absolute;top:calc(16px + env(safe-area-inset-top));right:16px;display:flex;align-items:center;justify-content:center;width:40px;height:40px;border:0;border-radius:var(--radius-full);background:rgba(255,255,255,.12);color:white;cursor:pointer}
.close:hover,.close:focus-visible{background:rgba(255,255,255,.22)}
.remove{display:inline-flex;align-items:center;gap:8px;min-height:44px;padding:10px 18px;border:1px solid var(--ck-fail-500);border-radius:var(--radius-md);background:transparent;color:var(--ck-fail-bg);font-weight:700;cursor:pointer}
.remove:hover{background:var(--ck-fail-500);color:white}
.remove:disabled{opacity:.6;cursor:not-allowed}

@media (prefers-reduced-motion: no-preference) {
  .lightbox{animation:fade-in 160ms ease-out}
}
@keyframes fade-in { from { opacity: 0 } to { opacity: 1 } }
</style>
